module.exports = __webpack_public_path__ + "static/media/shape.36a50500.svg";